import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button, Select } from 'antd'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import { Link, withRouter } from 'react-router-dom'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import FileCell from '../../../elements/Table/Cells/FileCell'
import PropTypes from 'prop-types'
import { formatQueryParams } from '../../../modules/Utils'

function statusFilterMethod (filter, row) {
  if (filter.value === 'all') {
    return true
  }

  if (filter.value.toLowerCase() === 'Confirmed'.toLowerCase()) {
    return row[filter.id] === 'Confirmed'
  }
  if (filter.value.toLowerCase() === 'Cancelled'.toLowerCase()) {
    return row[filter.id] === 'Cancelled'
  }
  if (filter.value.toLowerCase() === 'Draft'.toLowerCase()) {
    return row[filter.id] === 'Draft'
  }
  if (filter.value.toLowerCase() === 'Revised'.toLowerCase()) {
    return row[filter.id] === 'Revised'
  }
  if (filter.value.toLowerCase() === 'Closed'.toLowerCase()) {
    return row[filter.id] === 'Closed'
  }

  return false
}

function StatusFilter ({ onChange, filter }) {
  return (
    <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
      <Select.Option value={'Confirmed'}>Confirmed</Select.Option>
      <Select.Option value={'Cancelled'}>Cancelled</Select.Option>
      <Select.Option value={'Draft'}>Draft</Select.Option>
      <Select.Option value={'Revised'}>Revised</Select.Option>
      <Select.Option value={'Closed'}>Closed</Select.Option>
      <Select.Option value="all">All</Select.Option>
    </Select>
  )
}

const columns = [
  {
    Header: 'RFQ Code',
    accessor: 'code',
    width: 170,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/rfq/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Enquiry',
    accessor: 'enquiry.code',
    width: 170,
    hideable: true,
    hideDefault: false,
  },
  {
    Header: 'Due Date',
    accessor: 'date.due',
    width: 170,
    Cell: DateCell,
  },
  {
    Header: 'Vendor',
    accessor: 'vendor.fn',
    width: 300,
    style: { textAlign: 'left' },
  },
  {
    Header: 'Title',
    accessor: 'title',
    style: { textAlign: 'left' },
  },
  {
    Header: 'Issued',
    accessor: 'issuance.issued',
    width: 170,
    Cell: ({ value }) => value === true && <span>Issued</span>,
  },
  {
    Header: 'Status',
    accessor: 'status',
    filterMethod: statusFilterMethod,
    Filter: StatusFilter,
    width: 170,
    Cell: StatusCell,
  },
  {
    Header: 'File',
    accessor: 'file',
    Cell: FileCell,
    hideable: true,
    hideDefault: true,
  },
]

function RFQList (props) {
  const { list, fetch, fetching, company, onChangeCompany, enquiryID, hideCompany } = props
  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() =>
        hideCompany !== true && (
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )
      }
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() => {
            props.history.push({
              pathname: `/purchasing/rfq/new/`,
              search: formatQueryParams('enquiryID', enquiryID, true),
            })
          }}>
          New
        </Button>
      )}
      columns={columns}
    />
  )
}

export default withRouter(RFQList)
